import { IPartialLocaleValues } from "../interfaces/values";

/**
 * locale : Australian (en-AU)
 * author : Trevor Daniels : https://github.com/trevordaniels
 */

const enAU:IPartialLocaleValues = {
    datepicker: {
        firstDayOfWeek: 0
    }
};

export default enAU;
